if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

// =======================
// 🎥 START: Reset & replay video on return to video slide
// =======================

document.addEventListener('DOMContentLoaded', function () {
  const galleryElement = document.querySelector('media-gallery');

  if (!galleryElement) return;

  // Observer le changement de slide actif dans la galerie
  const observer = new MutationObserver(() => {
    const activeVideo = galleryElement.querySelector('li.is-active video');

    if (activeVideo && activeVideo.paused) {
      try {
        activeVideo.currentTime = 0; // Remet au début
        activeVideo.play(); // Relance la vidéo
        console.log('🎬 Vidéo relancée après retour sur la slide');
      } catch (err) {
        console.warn('⚠️ Impossible de relancer la vidéo :', err);
      }
    }
  });

  // Cibler la liste des médias du viewer
  const galleryList = galleryElement.querySelector('[id^="GalleryViewer"] ul');

  if (galleryList) {
    observer.observe(galleryList, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }
});

// =======================
// 🎥 END: Reset & replay video on return to video slide

// 🔁 AUTO-RESTART VIDEO WHEN RETURNING TO IT IN GALLERY
// Fixes a bug where video stops and doesn’t restart when switching between images and coming back.
// This reinitializes all <video> elements on section load or when media is changed.

document.addEventListener('shopify:section:load', () => {
  const videos = document.querySelectorAll('.product__media video');
  videos.forEach(video => {
    video.pause();
    video.currentTime = 0;
    video.play().catch(() => {
      // autoplay might be blocked on some mobile browsers, ignore error silently
    });
  });
});

document.addEventListener('mediaGallery:change', () => {
  const videos = document.querySelectorAll('.product__media video');
  videos.forEach(video => {
    video.pause();
    video.currentTime = 0;
    video.play().catch(() => {});
  });
});

// ✅ Mobile fix : supprimer lightbox et bouton play des vidéos
document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth >= 750) return; // Appliquer uniquement sur mobile

  // Supprimer les boutons de lightbox des vidéos
  document.querySelectorAll('.media-type-video .product__media-toggle').forEach(btn => btn.remove());

  // Supprimer l'icône de lecture (le "play" en haut à gauche)
  document.querySelectorAll('.media-type-video .product__media-icon').forEach(icon => icon.remove());
});
